// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bottom sheet for row actions on phones (see ActionSheet.jsx). */
.action-sheet .ant-drawer-content-wrapper {
  height: auto !important;
  max-height: 85dvh;
  box-shadow: var(--ds-shadow-lg) !important;
}

.action-sheet .ant-drawer-content {
  border-radius: var(--ds-radius-xl) var(--ds-radius-xl) 0 0;
  overflow: hidden;
}

.action-sheet .ant-drawer-body {
  padding: 0 0 calc(var(--ds-space-3) + var(--ds-safe-bottom)) !important;
}

.action-sheet__handle {
  width: 40px;
  height: 5px;
  margin: 10px auto 6px;
  border-radius: var(--ds-radius-pill);
  background: var(--ds-border);
}

.action-sheet__title {
  padding: var(--ds-space-1) var(--ds-space-5) var(--ds-space-2);
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--ds-text-2);
}

.action-sheet__list {
  list-style: none;
  margin: 0;
  padding: 0 var(--ds-space-2);
}

.action-sheet__item + .action-sheet__item {
  border-top: 1px solid var(--ds-border-soft);
}

/* Whatever button/link a row holds fills the row like a list item. */
.action-sheet__item > *,
.action-sheet__item > * > .ant-btn,
.action-sheet__item .ant-btn {
  width: 100%;
}

.action-sheet__item .ant-btn {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: var(--ds-space-3);
  height: auto;
  min-height: 52px;
  padding: 0 var(--ds-space-3);
  border: 0;
  border-radius: var(--ds-radius-md);
  background: transparent !important;
  box-shadow: none;
  color: var(--ds-text) !important;
  font-size: 1rem;
  font-weight: 500;
  text-align: start;
}

.action-sheet__item .ant-btn:active {
  background: var(--ds-surface-muted) !important;
}

.action-sheet__item .ant-btn > span {
  display: inline-flex;
  align-items: center;
  gap: var(--ds-space-3);
}

.action-sheet__item .ant-btn .anticon,
.action-sheet__item .ant-btn svg {
  font-size: 18px;
  color: var(--ds-text-2);
}

.action-sheet__item .ant-btn-dangerous,
.action-sheet__item .ant-btn-dangerous svg,
.action-sheet__item .is-danger .ant-btn,
.action-sheet__item .is-danger .ant-btn svg {
  color: var(--ds-danger) !important;
}

.action-sheet__item a:not(.ant-btn) {
  display: flex;
  align-items: center;
  min-height: 52px;
  padding: 0 var(--ds-space-3);
  color: var(--ds-text);
  font-size: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/design-system/ActionSheet.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;EACE,uBAAuB;EACvB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,0DAA0D;EAC1D,gBAAgB;AAClB;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,8DAA8D;EAC9D,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,qEAAqE;AACrE;;;EAGE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,SAAS;EACT,kCAAkC;EAClC,kCAAkC;EAClC,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,uBAAuB;AACzB;;AAEA;;;;EAIE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,eAAe;AACjB","sourcesContent":["/* Bottom sheet for row actions on phones (see ActionSheet.jsx). */\n.action-sheet .ant-drawer-content-wrapper {\n  height: auto !important;\n  max-height: 85dvh;\n  box-shadow: var(--ds-shadow-lg) !important;\n}\n\n.action-sheet .ant-drawer-content {\n  border-radius: var(--ds-radius-xl) var(--ds-radius-xl) 0 0;\n  overflow: hidden;\n}\n\n.action-sheet .ant-drawer-body {\n  padding: 0 0 calc(var(--ds-space-3) + var(--ds-safe-bottom)) !important;\n}\n\n.action-sheet__handle {\n  width: 40px;\n  height: 5px;\n  margin: 10px auto 6px;\n  border-radius: var(--ds-radius-pill);\n  background: var(--ds-border);\n}\n\n.action-sheet__title {\n  padding: var(--ds-space-1) var(--ds-space-5) var(--ds-space-2);\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--ds-text-2);\n}\n\n.action-sheet__list {\n  list-style: none;\n  margin: 0;\n  padding: 0 var(--ds-space-2);\n}\n\n.action-sheet__item + .action-sheet__item {\n  border-top: 1px solid var(--ds-border-soft);\n}\n\n/* Whatever button/link a row holds fills the row like a list item. */\n.action-sheet__item > *,\n.action-sheet__item > * > .ant-btn,\n.action-sheet__item .ant-btn {\n  width: 100%;\n}\n\n.action-sheet__item .ant-btn {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: var(--ds-space-3);\n  height: auto;\n  min-height: 52px;\n  padding: 0 var(--ds-space-3);\n  border: 0;\n  border-radius: var(--ds-radius-md);\n  background: transparent !important;\n  box-shadow: none;\n  color: var(--ds-text) !important;\n  font-size: 1rem;\n  font-weight: 500;\n  text-align: start;\n}\n\n.action-sheet__item .ant-btn:active {\n  background: var(--ds-surface-muted) !important;\n}\n\n.action-sheet__item .ant-btn > span {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--ds-space-3);\n}\n\n.action-sheet__item .ant-btn .anticon,\n.action-sheet__item .ant-btn svg {\n  font-size: 18px;\n  color: var(--ds-text-2);\n}\n\n.action-sheet__item .ant-btn-dangerous,\n.action-sheet__item .ant-btn-dangerous svg,\n.action-sheet__item .is-danger .ant-btn,\n.action-sheet__item .is-danger .ant-btn svg {\n  color: var(--ds-danger) !important;\n}\n\n.action-sheet__item a:not(.ant-btn) {\n  display: flex;\n  align-items: center;\n  min-height: 52px;\n  padding: 0 var(--ds-space-3);\n  color: var(--ds-text);\n  font-size: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
